var map = {
	"./BC.png": 33456,
	"./BMC.png": 18135,
	"./CISCO.png": 76352,
	"./HU.jpeg": 37837,
	"./IEEE.png": 99957,
	"./LogoBig.png": 78640,
	"./NHS.jpeg": 6801,
	"./RE1Mu3b.png": 68136,
	"./TREND.png": 55556,
	"./citc_logo.svg": 16948,
	"./esri-logo-globe-tm.png": 4250,
	"./logo (1).png": 34734,
	"./logo.png": 40188,
	"./logo.svg": 7744,
	"./logo_dark.png": 22541,
	"./mh-logo.png": 13144,
	"./vmware-logo-grey.svg": 33005,
	"./المركز الوطنى لإدارة النفايات.png": 92381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7601;